import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import Administration from 'pages/Administration/Administration';
import AuthRoute from 'components/AuthRoute/AuthRoute';
import Distribution from 'pages/Distribution/Distribution';
import InfoMessages from 'pages/InfoMessages/InfoMessages';
import Layout from 'components/Layout/Layout';
import Login from 'pages/Login/Login';
import { ROLES } from 'constants/roles';
import ROUTES from 'constants/routes';
import Recommendations from 'pages/Recommendations/Recommendations';
import RoleProtectedRoute from 'components/RoleProtectedRoute/RoleProtectedRoute';
import Settings from 'pages/Settings/Settings';
import { loadCitiesAction } from 'store/dictionaries/dictionaries.actions';
import { useAppDispatch } from 'store';

const App: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(loadCitiesAction());
  }, [dispatch]);

  return (
    <Routes>
      <Route path={ROUTES.LOGIN} element={<Login />} />
      <Route
        path="/*"
        element={
          <Layout>
            <AuthRoute>
              <Routes>
                <Route
                  path={ROUTES.ADMINISTRATION}
                  element={
                    <RoleProtectedRoute role={ROLES.ROLE_ADMIN}>
                      <Administration />
                    </RoleProtectedRoute>
                  }
                />
                <Route path={ROUTES.SETTINGS} element={<Settings />} />
                <Route path={ROUTES.DISTRIBUTION} element={<Distribution />} />
                <Route path={ROUTES.RECOMMENDATIONS} element={<Recommendations />} />
                <Route path={ROUTES.INFO_MESSAGES} element={<InfoMessages />} />
                <Route path="*" element={<div style={{ fontSize: 22 }}>Не выбран раздел</div>} />
              </Routes>
            </AuthRoute>
          </Layout>
        }
      />
    </Routes>
  );
};

export default App;
